import React from 'react';
import styles from './Auth.organisms.Content.HiAgain.module.scss';
import RoundedButton from '../../../../../components/Auth/atoms/buttons/RoundedButton'
import ModalButton from '../../../../../components/Auth/atoms/modals/ModalButton'
import PasswordInput from '../../../../../components/Auth/atoms/forms/InputPasswordAuth'
import AccountDropdown from '../../../../../components/Auth/atoms/forms/DropdownAccount';

import Logo from 'components/Auth/atoms/images/Logo'
import { Link } from 'react-router-dom';
import i18n from 'i18n';
import { capitalize } from "helpers/utils/utils_general";

export class HiAgain extends React.Component {
    render() {
        const {
            handleChange,
            handleSelectAccount,
            handleSubmit,
            buttonState = 'diabled',
            errors,
            errorMessage,
            accounts,
            handleAddEmail
        } = this.props;

        return (
            <div className={styles["hi-again"]}>
                <form onSubmit={handleSubmit}>
                    <Logo></Logo>
                    <p className={styles["title"]}>{i18n.t("hello.again")}</p>
                    <div className={styles["form-container"]}>
                        <div className={styles["inputs-wrapper"]}>
                            <AccountDropdown accountList={accounts} handleAddEmail={handleAddEmail} handleSelectAccount={handleSelectAccount} id={'user'} email={this.props.selectedUser}></AccountDropdown>
                            <PasswordInput handleChange={handleChange} id={'password'} error={errorMessage ? errorMessage : errors.password}></PasswordInput>
                        </div>
                        <div className={styles["remember-row"]}>
                            <Link to="/forgotten" className={styles["link"]}><button data-automation-id="forgot-password" type="button">{i18n.t("forgot.password")}</button></Link>
                        </div>
                    </div>
                    <div className={styles["rounded-button-wrapper"]}>
                        <RoundedButton legend={capitalize(i18n.t("enter"))} handleClick={handleSubmit} state={buttonState}></RoundedButton>
                    </div>
                </form>
            </div>
        )
    }

}


HiAgain.propTypes = {};

export default HiAgain;